import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { cPath } from "../../constants";

const H1 = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
`;

const Card = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1.25rem;
  margin-bottom: 0.75rem;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const Title = styled(Link)`
  font-size: 0.875rem;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
  &:hover {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

const Empty = styled.p`
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  font-size: 0.9375rem;
`;

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}

export default function DashboardComments() {
  const { isAuthenticated } = useSelector((s) => s.auth);
  const { myComments } = useSelector((s) => s.user);

  const rows = myComments.map((c) => ({
    id: c.id,
    couponId: c.couponPublicId,
    couponTitle: c.couponTitle || "Coupon",
    storeName: c.storeName || "",
    text: c.body,
    postedAt: formatDate(c.createdAt),
  }));

  if (!isAuthenticated) {
    return (
      <div>
        <H1>My Comments</H1>
        <Empty>Sign in to see your comments.</Empty>
      </div>
    );
  }

  return (
    <div>
      <H1>My Comments</H1>
      {rows.length === 0 && (
        <Empty>No comments yet. Post on a coupon page when logged in.</Empty>
      )}
      {rows.map((comment) => (
        <Card key={comment.id}>
          <Top>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Title to={cPath(`coupon/${comment.couponId}`)}>{comment.couponTitle}</Title>
              {comment.storeName ? (
                <span style={{ fontSize: "0.75rem", color: "hsl(220 10% 46%)" }}>
                  • {comment.storeName}
                </span>
              ) : null}
            </div>
            <span style={{ fontSize: "0.75rem", color: "hsl(220 10% 46%)" }}>
              {comment.postedAt}
            </span>
          </Top>
          <p style={{ margin: "0 0 0.75rem", fontSize: "0.875rem", color: "hsl(220 10% 46%)" }}>
            {comment.text}
          </p>
        </Card>
      ))}
    </div>
  );
}
